import {
  PriceTierOrderRuleUpdateRequestType,
  PriceTierOrderRuleUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

/** @deprecated Use usePriceListOrderRuleUpdate for the canonical PriceList contract. */
export const usePriceTierOrderRuleUpdate = (priceTierOrderRuleId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PriceTierOrderRuleUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `price-tier-order-rules/${priceTierOrderRuleId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as PriceTierOrderRuleUpdateResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTierOrderRules],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.PriceTierOrderRules,
          priceTierOrderRuleId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OrderRules],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.FulfillmentType],
      });
    },
  });
};
